import Vue from 'vue'
import Constants from 'src/utilities/constants'
import {OK, SERVICE_UNAVAILABLE} from 'http-status-codes'
import {esClient} from 'src/utilities/ptracSearch'
import {ptracApiUp, ptracGet} from 'src/utilities/ptracApi'
import {fileManagerApiUp} from 'src/utilities/fileManagerApi'
import {get} from 'src/utilities/axios2'
import {make} from 'vuex-pathify'
import {autoRoutingApiUp} from '@/utilities/autoRoutingApi'

const initialState = {
  services: {
    autoRoutingApi: {
      name: 'Auto Routing API',
      state: Constants.HEALTH_CHECK_STATUSES.LOADING
    },
    elasticsearchApi: {
      name: 'Elasticsearch',
      state: Constants.HEALTH_CHECK_STATUSES.LOADING
    },
    ptracApi: {
      name: 'PTRAC API',
      state: Constants.HEALTH_CHECK_STATUSES.LOADING
    },
    fileManagerApi: {
      name: 'File Manager',
      state: Constants.HEALTH_CHECK_STATUSES.LOADING
    },
    monstacheService: {
      name: 'Monstache Service',
      state: Constants.HEALTH_CHECK_STATUSES.LOADING
    },
    quickbooks: {
      name: 'QuickBooks',
      state: Constants.HEALTH_CHECK_STATUSES.LOADING
    }
  }
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))
const getters = make.getters(state)
const mutations = make.mutations(state)
mutations.ptracActive = (state, payload) => {
  state.services.ptracApi.state = payload
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchAll({dispatch}) {
      await dispatch('ptracApi') //only wait for PTRAC API - let the rest run async
      dispatch('autoRoutingApi')
      dispatch('fileManagerApi')
      dispatch('monstacheService')
      dispatch('elasticsearchApi')
      dispatch('quickbooks')
    },
    async elasticsearchApi({state, dispatch, rootState, rootGetters}) {
      let response = {}

      if (Object.keys(rootState.config).length === 0) {
        await dispatch('config/fetchAll', null, {root: true}) // needed by the line below
      }

      const esCreds = rootGetters['config/byName'](Constants.CONFIGS.ELASTICSEARCH_UN_PW)

      if (esCreds == null && Constants.ENVIRONMENTS.DEVELOPMENT !== process.env.NODE_ENV) {
        console.log('esCreds are null. Unable to perform Elasticsearch health check.')
        return
      }

      try {
        response = await esClient(esCreds).search({index: 'ptrac'})
        if (response.hits) {
          state.services.elasticsearchApi.state = Constants.HEALTH_CHECK_STATUSES.UP
          response.status = OK // hack so BackingServices.vue notifies correctly
          this.$eventHub.$emit('elasticsearch-api-up')
        }
      } catch (err) {
        state.services.elasticsearchApi.state = Constants.HEALTH_CHECK_STATUSES.DOWN
        response.status = SERVICE_UNAVAILABLE
        this.$eventHub.$emit('elasticsearch-api-down')
        console.error(err)
      }

      return response
    },
    async autoRoutingApi({state}) {
      const response = await autoRoutingApiUp()

      if (OK === response.status) {
        this.$eventHub.$emit('auto-routing-api-up')
        state.services.autoRoutingApi.state = Constants.HEALTH_CHECK_STATUSES.UP
      } else {
        state.services.autoRoutingApi.state = Constants.HEALTH_CHECK_STATUSES.DOWN
        this.$eventHub.$emit('auto-routing-api-down')
        console.error(response)
      }

      return response
    },
    async ptracApi({state}) {
      const response = await ptracApiUp()

      if (OK === response.status) {
        this.$eventHub.$emit('ptrac-api-up')
        state.services.ptracApi.state = Constants.HEALTH_CHECK_STATUSES.UP
      } else {
        state.services.ptracApi.state = Constants.HEALTH_CHECK_STATUSES.DOWN
        this.$eventHub.$emit('ptrac-api-down')
        console.error(response)
      }

      return response
    },
    async fileManagerApi({state}) {
      const response = await fileManagerApiUp()

      if (OK === response.status) {
        state.services.fileManagerApi.state = Constants.HEALTH_CHECK_STATUSES.UP
        this.$eventHub.$emit('file-manager-api-up')
      } else {
        state.services.fileManagerApi.state = Constants.HEALTH_CHECK_STATUSES.DOWN
        this.$eventHub.$emit('file-manager-api-down')
        console.error(response)
      }

      return response
    },
    async monstacheService({state}) {
      const response = await get(
        process.env.VUE_APP_PTRAC_API_URI + '/health/monstache-service', Constants.HEADERS.DEFAULT.headers)

      if (OK === response.status) {
        this.$eventHub.$emit('monstache-service-up')
        state.services.monstacheService.state = Constants.HEALTH_CHECK_STATUSES.UP
      } else {
        state.services.monstacheService.state = Constants.HEALTH_CHECK_STATUSES.DOWN
        this.$eventHub.$emit('monstache-service-down')
        console.error(response)
      }

      return response
    },
    async quickbooks({state}) {
      const response = await ptracGet('quickbooks/customer-exists?name=KB%20Home')

      if (OK !== response.status) {
        state.services.quickbooks.state = Constants.HEALTH_CHECK_STATUSES.ERROR
        console.error('Error receiving response from QuickBooks Health Check', response)
        return response
      }

      const customerExists = response.data
      if (customerExists.quickbooksOnline) {
        this.$eventHub.$emit('quickbooks-up')
        state.services.quickbooks.state = Constants.HEALTH_CHECK_STATUSES.UP
      } else {
        state.services.quickbooks.state = Constants.HEALTH_CHECK_STATUSES.DOWN
        response.status = SERVICE_UNAVAILABLE // hack so BackingServices.vue notifies correctly
        this.$eventHub.$emit('quickbooks-down')
        console.error('QuickBooks is Down', response)
      }

      return response
    }
  }
}
